export class BubbleChart {
  title: string;
  barChartData: any[] = [];
  barChartLegend: boolean;
  barChartType: string;
  barChartOptions: any;
}
